import React from 'react'
import Nav from './commons/nav/index';
import { Outlet } from 'react-router-dom'

const Home = () => {
    return (
        <Nav>
            <Outlet />
        </Nav>
    )
}

export default Home